// src/guards/is-integer/is-integer.ts
var isInteger = (value) => Number.isInteger(value);

export {
  isInteger
};
